// src/components/TrustBarSection.jsx
import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const trustItems = [
  "100+ Countries",
  "100+ Million Users",
  "KYC-Verified",
  "200+ Roles",
  "29+ Categories",
  "24 Markets",
  "0% Scam",
];

const miniTestimonials = [
  {
    quote:
      "M2T unlocked international clients for my business overnight. Real trust, real results.",
    name: "Ramya Patel ",
    role: "Market Analyst, India",
    rating: 5,
    avatar: "/assets/review/review1.jpg",
  },
  {
    quote:
      "Our company scaled faster on M2T than anywhere else—every connection is verified and valuable.",
    name: "Peter van der Berg",
    role: "Institution Owner, Netherlands",
    rating: 5,
    avatar: "/assets/review/review2.jpg",
  },
  {
    quote:
      "I get paid instantly and connect with trusted traders worldwide. It’s a game changer.",
    name: "Moses Ochieng",
    role: "Retail Trader, Turkey",
    rating: 5,
    avatar: "/assets/review/review3.jpg",
  },
  {
    quote:
      "I no longer worry about scams or fake signals. With M2T, every opportunity is real and verified.",
    name: "Sheik Mohammed ",
    role: "Forex Strategist, UAE",
    rating: 5,
    avatar: "/assets/review/review4.jpg",
  },
  {
    quote:
      "Joining M2T boosted my income, my network, and my reputation—all in one place.",
    name: "Prakash Sharma",
    role: "Algo Developer, India",
    rating: 5,
    avatar: "/assets/review/review5.jpg",
  },
  {
    quote:
      "I found business partners, investors, and clients—all through my verified SmartCard.",
    name: "Sofia Rossi",
    role: "Fund Manager, Italy",
    rating: 5,
    avatar: "/assets/review/review6.jpg",
  },
  {
    quote: "Every profile here is serious. It saves time and protects capital.",
    name: "Aisha Noor",
    role: "Prop Trader, Germany",
    rating: 5,
    avatar: "/assets/review/review7.jpg",
  },
  {
    quote:
      "M2T feels like LinkedIn, TradingView, and Stripe combined—with trust built in.",
    name: "Jennifer Joseph",
    role: "FinTech Consultant, UK",
    rating: 5,
    avatar: "/assets/review/review8.jpg",
  },
  {
    quote: "Finally, a platform where verification actually means something.",
    name: "Lucas Martin",
    role: "Investment Advisor, France",
    rating: 5,
    avatar: "/assets/review/review9.jpg",
  },
];

export default function TrustBarSection() {
  const [trustIdx, setTrustIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(
      () => setTrustIdx((i) => (i + 1) % trustItems.length),
      1500,
    );
    return () => clearInterval(t);
  }, []);

  return (
    <section className="bg-[#0B0F19] py-20">
      <div className="mx-auto mb-48 max-w-6xl px-4 text-left">
        <h2 className="mb-2 text-4xl font-bold text-white">Reviews</h2>
        <p className="mb-10 text-lg text-gray-500">
          See why professionals worldwide trust Million2Trillion.
        </p>

        {/* ===== TESTIMONIALS ===== */}
        <div className="mb-12 mt-2 flex flex-wrap justify-center gap-14">
          {miniTestimonials.map((t, i) => (
            <div
              key={i}
              className="max-w-xs rounded-xl border border-blue-900/60 bg-[#0c1120] p-5 text-left shadow-sm"
            >
              {/* Rating */}
              <div className="mb-2 flex items-center">
                {[...Array(t.rating)].map((_, idx) => (
                  <span
                    key={idx}
                    className="text-lg leading-none text-amber-400"
                  >
                    ★
                  </span>
                ))}
              </div>

              {/* Quote */}
              <p className="mb-4 text-sm italic leading-snug text-white/80">
                “{t.quote}”
              </p>

              {/* Avatar + Name */}
              <div className="mt-3 flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="h-10 w-10 rounded-full border border-white/20 object-cover"
                />
                <div className="text-xs">
                  <div className="font-medium text-blue-200">{t.name}</div>
                  <div className="text-gray-400">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
